module.exports = __webpack_public_path__ + "static/img/1bw.8b247707.webp";